export enum WebViewScope {
  MOBILE_PRO = 'mobilePro',
  MOBILE_HOMEOWNER = 'mobileHomeowner',
}

// Utility function to help determine if the code is running in a webview
// NOTE: Does not currently detect if ssr request was from a webview.
export const isWebView = (scope?: WebViewScope) => {
  // if window is undefined, exit early as we're not in a browser environment
  if (typeof window === 'undefined') {
    return false;
  }

  const isRNWebView = Boolean(window.ReactNativeWebView);
  // if no scope is provided, return if it's a webview
  if (!scope || !isRNWebView) {
    return isRNWebView;
  }

  return window.HOVERApp?.appReferrer === scope;
};
